import React from 'react';
import { Target, Eye, Award } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export const AboutSection = () => {
  const { t } = useLanguage();

  return (
    <section id="sobre" className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t('about.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('about.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {/* Missão */}
          <div className="text-center group">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-primary/20 transition-colors duration-300">
              <Target className="w-8 h-8 text-primary" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-4">{t('about.mission.title')}</h3>
            <p className="text-gray-600 leading-relaxed">
              {t('about.mission.description')}
            </p>
          </div>

          {/* Visão */}
          <div className="text-center group">
            <div className="w-16 h-16 bg-secondary/10 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-secondary/20 transition-colors duration-300">
              <Eye className="w-8 h-8 text-secondary" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-4">{t('about.vision.title')}</h3>
            <p className="text-gray-600 leading-relaxed">
              {t('about.vision.description')}
            </p>
          </div>

          {/* Diferencial */}
          <div className="text-center group">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-primary/20 transition-colors duration-300">
              <Award className="w-8 h-8 text-primary" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-4">{t('about.differential.title')}</h3>
            <p className="text-gray-600 leading-relaxed">
              {t('about.differential.description')}
            </p>
          </div>
        </div>

        {/* Segmentos Atendidos */}
        <div className="bg-gray-50 rounded-2xl p-8">
          <h3 className="text-2xl font-bold text-gray-900 text-center mb-8">
            {t('about.segments.title')}
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-4">
            {t('segments').map((segment, index) => (
              <div 
                key={index}
                className="bg-white rounded-lg p-4 text-center shadow-sm hover:shadow-md transition-shadow duration-300"
              >
                <span className="text-sm font-medium text-gray-900">{segment}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};